import { convertHexToRgbA } from '../utils';

const COLOR_SCHEME = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	LIGHT: 'light',
	DARK: 'dark',
	NEUTRAL: 'neutral',
	GHOST: 'ghost'
};

export const COLOR_SCHEME_STATES = {
	[COLOR_SCHEME.PRIMARY]: {
		normal: {
			backgroundColor: '#EAAE16'
		},
		hover: {
			backgroundColor: '#FFD029'
		},
		active: {
			backgroundColor: '#D39D14'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.LIGHT]: {
		normal: {
			backgroundColor: '#ffffff'
		},
		hover: {
			backgroundColor: '#E5E5E5'
		},
		active: {
			backgroundColor: '#D9D9D9'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.DARK]: {
		normal: {
			backgroundColor: '#2E4B96'
		},
		hover: {
			backgroundColor: '#375AB4'
		},
		active: {
			backgroundColor: '#253C78'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.NEUTRAL]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	},
	[COLOR_SCHEME.GHOST]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	}
};
